/* Welcome Kit v2 — sticky CTA reveal + subscription add-to-cart.
   Deliberately small and dependency-free. It does NOT introduce a cart or an
   analytics stack of its own: it posts to the theme's cart route and then fires
   the theme's own events, which is what opens the drawer and what the store's
   existing ecommerce tracking already listens to. */
(function () {
  'use strict';

  /* ── sticky CTA ──────────────────────────────────────────────────────
     Reveal once the anchor (the hero) has left the viewport.
     NOTE: a rootMargin of '0px 0px -100% 0px' collapses the observer root to a
     ZERO-AREA rect, which never reports a change and leaves the bar hidden for
     ever. Observe against the real viewport instead. */
  function stickies() {
    document.querySelectorAll('[data-wk-sticky]').forEach(function (bar) {
      if (bar.__wk) return;
      bar.__wk = true;
      var anchor = document.getElementById(bar.dataset.wkAnchor || 'wk-hero');
      if (!anchor) return;

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          bar.classList.toggle('is-on', !entries[0].isIntersecting);
        }, { threshold: 0 }).observe(anchor);
        return;
      }
      var ticking = false;                       /* fallback */
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          bar.classList.toggle('is-on', anchor.getBoundingClientRect().bottom <= 0);
          ticking = false;
        });
      }, { passive: true });
    });
  }

  /* ── add to cart ─────────────────────────────────────────────────────
     ⚠️ Cart contract: post ONLY the paid subscription line. The three Welcome
     Kit gifts are attached app-side from cart rules and are never line items;
     adding them here would give the customer double free product.

     The event payloads below are NOT decorative — they are read directly by
     theme.js, and were reverse-engineered from it rather than guessed:
       · `cart:prepare-bundled-sections` detail MUST be { sections: [] }; every
         listener does `event.detail.sections.push(...)`, so a missing array
         throws and the drawer never learns which sections to re-render.
       · the add request MUST carry `sections` + `sections_url`, because the
         drawer rebuilds its markup from `cart.sections` in the response.
       · `cart:change` detail MUST carry `cart`; listeners read
         `event.detail.cart.item_count`.
     Getting these wrong still "works" (the drawer opens) but throws two console
     errors and leaves the drawer rendering stale contents. */
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function message(res, data) {
    if (data && data.description) return data.description;
    if (data && data.message) return data.message;
    if (res && res.status === 422) return 'This item could not be added to your cart.';
    return 'Something went wrong. Please try again.';
  }

  function submit(form, e) {
    e.preventDefault();
    if (form.classList.contains('is-busy')) return;      /* no double submission */
    form.classList.add('is-busy');

    var btn = form.querySelector('button[type="submit"]');
    var err = form.querySelector('[data-wk-atc-error]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    if (err) { err.hidden = true; err.textContent = ''; }

    /* let every listening section register itself for re-rendering */
    var sectionsToBundle = ['variant-added'];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true, detail: { sections: sectionsToBundle }
    }));

    var variantId = (form.querySelector('input[name="id"]') || {}).value;
    var body = new FormData(form);
    body.set('sections', sectionsToBundle.join(','));
    body.set('sections_url', ROOT + 'variants/' + variantId);

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (res) {
        return res.json().then(function (data) { return { res: res, data: data }; });
      })
      .then(function (r) {
        if (!r.res.ok || r.data.status) throw r;
        return fetch(ROOT + 'cart.js')
          .then(function (c) { return c.json(); })
          .then(function (cart) {
            cart.sections = r.data.sections;
            var items = r.data.hasOwnProperty('items') ? r.data.items : [r.data];
            /* dispatched on the form so it bubbles the way the theme's own
               product-form does; the drawer listens on document */
            form.dispatchEvent(new CustomEvent('variant:add', {
              bubbles: true, detail: { items: items, cart: cart }
            }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
              bubbles: true, detail: { baseEvent: 'variant:add', cart: cart }
            }));
            /* keep keyboard focus inside the drawer once it opens */
            window.setTimeout(function () {
              var drawer = document.querySelector('cart-drawer, #cart-drawer, .cart-drawer');
              if (!drawer) return;
              var target = drawer.querySelector(
                '[autofocus], button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
              );
              if (target) target.focus();
            }, 220);
          });
      })
      .catch(function (r) {
        var txt = message(r && r.res, r && r.data);
        if (err) { err.textContent = txt; err.hidden = false; }
        form.dispatchEvent(new CustomEvent('cart:error', {
          bubbles: true, detail: { error: txt }
        }));
      })
      .then(function () {
        form.classList.remove('is-busy');
        if (btn) btn.removeAttribute('aria-busy');
      });
  }

  function forms() {
    document.querySelectorAll('form[data-wk-atc]').forEach(function (form) {
      if (form.__wk) return;
      form.__wk = true;
      form.addEventListener('submit', function (e) { submit(form, e); });
    });
  }

  function init() { stickies(); forms(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Theme Editor re-renders a section without a page load */
  document.addEventListener('shopify:section:load', init);
})();
